import { toast } from 'vue-sonner';
import type { Message } from '~/types/models';

export function useMessageResponseFollowUp() {
    const messagesStore = useMessagesStore();
    const responseActionLoadingId = ref('');

    async function run(message: Message, action: 'mark_waiting' | 'send_reminder' | 'resolve') {
        if (responseActionLoadingId.value) return;
        responseActionLoadingId.value = message.id;
        try {
            await messagesStore.updateResponseFollowUp(message.id, action);
            toast.success(action === 'mark_waiting'
                ? 'Message marked as waiting for a response.'
                : action === 'send_reminder'
                    ? 'Response reminder sent.'
                    : 'Response wait resolved.');
        } catch (error: any) {
            toast.error(error?.data?.statusMessage || error?.message || 'Could not update the response reminder.');
        } finally {
            responseActionLoadingId.value = '';
        }
    }

    return {
        responseActionLoadingId,
        markResponseNeeded: (message: Message) => run(message, 'mark_waiting'),
        sendResponseReminder: (message: Message) => run(message, 'send_reminder'),
        resolveResponse: (message: Message) => run(message, 'resolve'),
    };
}
